<template>
  <div class="home-container container-fluid p-0">
    <div class="row g-3 align-items-stretch min-vh-100">
      <!-- Left Column -->
      <div class="col-12 col-lg-4 col-xl-3 d-flex">
        <div class="card shadow-sm flex-fill w-100">
          <div class="card-body p-2">
            <CandidateInfoUserView
              v-if="candidateProfile"
              :item="candidateInfoData"
            />
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-12 col-lg-8 col-xl-9 d-flex">
        <div class="card shadow-sm flex-fill w-100">
          <div class="card-body d-flex flex-column p-3">
            <!-- One CTabs for both Desktop & Mobile -->
            <CTabs
              variant="tabs"
              :active-tab="activeTab"
              @update:activeTab="setTabActive"
              class="home-tabs d-flex flex-column flex-fill"
            >
              <CTab title="Overview">
                <div v-if="activeTabName === 'overview'">
                  <CandidateListUserView :item="candidateProfile" />
                </div>
              </CTab>

              <CTab :title="`Jobs Applied (${getAppliedCount})`">
                <AppliedJobs v-if="activeTabName === 'applied'" />
              </CTab>

              <CTab :title="`Jobs Withdrawn (${getWithdrawCount})`">
                <WithdrawJobs v-if="activeTabName === 'withdrawn'" />
              </CTab>

              <CTab :title="`Favourite Jobs (${getFavoCount})`">
                <FavouriteJobs v-if="activeTabName === 'favourite'" />
              </CTab>

              <CTab :title="`New Jobs (${getMatchedCount})`">
                <MatchedJobs v-if="activeTabName === 'new-jobs'" />
              </CTab>

              <CTab :title="`Campaigns (${getCandidateCampaignsCount})`">
                <CandidateCampaigns v-if="activeTabName === 'campaigns'" />
              </CTab>

              <CTab :title="`Messages (${getUniqConversation.length})`">
                <EmailMessages
                  v-if="activeTabName === 'messages' && candidateProfile"
                  :email="candidateProfile.email"
                  :candidate_uid="candidateProfile.candidate_uid"
                  :customer_uid="candidateProfile.customer_uid"
                  :organisation_id="candidateProfile.organisation_id"
                />
              </CTab>

              <CTab
                :title="`Schedules (${pendingInterview.length})`"
                v-show="pendingInterview.length"
              >
                <Schedules
                  v-if="activeTabName === 'schedules'"
                  :schedule="getCandidateInterviewSchedules"
                />
              </CTab>

              <CTab
                :title="`Offer & Onboarding (${checkListJobsCount})`"
              >
                <div v-if="checkListJobsCount && activeTabName === 'offer'">
                  <OfferOnboardingDocument
                    :preOfferDocs="preOfferCandidateDocs"
                    :offerDocs="getCandidateOffers"
                    :licensingDocs="getCandidateOnBoardDocs"
                    :visaDocs="visaCandidateDocs"
                    :joiningDocs="joiningCandidateDocs"
                    :preOfferJobs="preOfferJobs"
                    :offerJobs="offerJobs"
                    :licensingJobs="licensingJobs"
                    :visaJobs="visaJobs"
                    :joiningJobs="joiningJobs"
                  />
                </div>
              </CTab>

              <CTab :title="`Courses / Programmes (${getCandidateEnrollments.length})`">
                <CoursesAndProgrammes
                  v-if="activeTabName === 'courses'"
                  :courseProgramme="courseProgramme"
                />
              </CTab>

              <CTab title="Sponsorship (0)">
                <Sponsorship v-if="activeTabName === 'sponsorship'" />
              </CTab>
            </CTabs>

            <!-- Toast Notification -->
            <CToaster
              v-if="toast"
              :autohide="toastHide"
              position="bottom-right"
            >
              <CToast :class="toastClass" :show="true">{{
                toastMessage
              }}</CToast>
            </CToaster>
          </div>
        </div>
      </div>
    </div>

    <CandidateLoginAlert
      v-if="showLoginAlert"
      :isShowPopup="showLoginAlert"
      :alerts="getCandidateLoginAlerts"
      @close="showLoginAlert = false"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import CandidateListUserView from "@/containers/CandidateList/CandidateListUserView";
import CandidateInfoUserView from "@/containers/CandidateList/CandidateInfoUserView";
import AppliedJobs from "@/containers/CandidateProfile/AppliedJobs";
import WithdrawJobs from "@/containers/CandidateProfile/WithdrawJobs";
import FavouriteJobs from "@/containers/CandidateProfile/FavouriteJobs";
import MatchedJobs from "@/containers/CandidateProfile/MatchedJobs";
import EmailMessages from "@/containers/CandidateProfile/EmailMessages";
import Schedules from "@/containers/CandidateProfile/Schedules";
import OfferDocuments from "@/containers/CandidateProfile/OfferDocuments";
import OfferOnboardingDocument from "@/containers/CandidateProfile/OfferOnboardingDocument";
import { CONSTANT as CONST } from "@/helpers/helper";
import Sponsorship from "@/containers/CandidateProfile/Sponsorship.vue";
import CoursesAndProgrammes from "@/containers/CandidateProfile/CoursesAndProgrammes.vue";
import CandidateCampaigns from "../containers/CandidateProfile/CandidateCampaigns.vue";
import CandidateLoginAlert from "@/containers/CandidateProfile/CandidateLoginAlert";

export default {
  name: "HomePage",
  components: {
    CandidateListUserView,
    CandidateInfoUserView,
    AppliedJobs,
    FavouriteJobs,
    MatchedJobs,
    WithdrawJobs,
    EmailMessages,
    Schedules,
    OfferDocuments,
    OfferOnboardingDocument,
    Sponsorship,
    CoursesAndProgrammes,
    CandidateCampaigns,
    CandidateLoginAlert,
  },
  data() {
    return {
      activeTab: 0,
      activeTabName: 'overview',
      showLoginAlert: false,
      tabNames: [
        'overview',
        'applied',
        'withdrawn',
        'favourite',
        'new-jobs',
        'campaigns',
        'messages',
        'schedules',
        'offer',
        'courses',
        'sponsorship',
      ],
    };
  },
  computed: {
    ...mapGetters([
      "toast",
      "toastMessage",
      "toastClass",
      "toastHide",
      "candidateProfile",
      "getCustomerId",
      "getAppliedJobsCount",
      "getWithdrawJobsCount",
      "getFavoJobsCount",
      "getMatchedJobsCount",
      "getCandidateEmailMessages",
      "getCandidateOffers",
      "getCandidateInterviewSchedules",
      "getCandidateOnBoardDocs",
      "preOfferCandidateDocs",
      "visaCandidateDocs",
      "joiningCandidateDocs",
      "getCustomerTypeIDFromAccessToken",
      "getCandidateCourseProgramme",
      "getPathAcronymFromAccessToken",
      "getCandidateCampaignsCount",
      "courseList",
      "getCandidateEnrollments",
      "getCandidateLoginAlerts",
    ]),
    pendingInterview() {
      return (
        this.getCandidateInterviewSchedules.filter(
          (v) => v.status_id === 54 && v.sub_status_id === 55
        ) || []
      );
    },
    offerJobIDs() {
      return new Set(this.getCandidateOffers.map((val) => val.job_id));
    },
    onBoardJobIDs() {
      return new Set(this.getCandidateOnBoardDocs.map((val) => val.job_id));
    },
    getFavoCount() {
      return this.getFavoJobsCount;
    },
    getAppliedCount() {
      return this.getAppliedJobsCount;
    },
    getWithdrawCount() {
      return this.getWithdrawJobsCount;
    },
    getMatchedCount() {
      return this.getMatchedJobsCount;
    },
    getUniqConversation() {
      let array = [];
      array = _.uniqBy(this.getCandidateEmailMessages, (v) =>
        [
          v.sender,
          v.subject.split(": ")[1] ? v.subject.split(": ")[1] : v.subject,
        ].join()
      );
      return this.getCandidateEmailMessages.length ? array : [];
    },
    getUnreadMessages() {
      return this.getUniqConversation
        ? _.filter(
            this.getUniqConversation,
            (message) => message.direction === "O" && !message.read
          )
        : [];
    },
    preOfferJobs() {
      return (
        _.keys(_.groupBy(this.preOfferCandidateDocs, (doc) => doc.job_id)) || []
      );
    },
    offerJobs() {
      return (
        _.keys(_.groupBy(this.getCandidateOffers, (doc) => doc.job_id)) || []
      );
    },
    licensingJobs() {
      return (
        _.keys(_.groupBy(this.getCandidateOnBoardDocs, (doc) => doc.job_id)) ||
        []
      );
    },
    visaJobs() {
      return (
        _.keys(_.groupBy(this.visaCandidateDocs, (doc) => doc.job_id)) || []
      );
    },
    joiningJobs() {
      return (
        _.keys(_.groupBy(this.joiningCandidateDocs, (doc) => doc.job_id)) || []
      );
    },
    checkListJobsCount() {
      return (
        this.preOfferJobs.length +
        this.offerJobs.length +
        this.licensingJobs.length +
        this.visaJobs.length +
        this.joiningJobs.length
      );
    },
    isEducationalType() {
      return (
        this.candidateProfile?.customer_type_id ===
          CONST.CUSTOMER_TYPES.educational_institute || false
      );
    },
    isStudent() {
      return this.candidateProfile?.is_student || false;
    },
    candidateInfoData() {
      let {
        first_name,
        surname,
        email,
        gender: { gender },
        title: { title },
        speciality: { speciality },
        sub_speciality: { sub_speciality },
        candidate_level: { candidate_level },
        candidate_type: { candidate_type },
        nationality,
        location,
        dob,
        age,
        main_qualification: { qualification },
        main_qualification_year,
        phone,
        eligibility_letter_available_for,
        local_license,
        dataflow_complete,
        candidate_uid,
        whatsapp,
        available,
        job_type,
        job_time,
        flexible,
        extra_hours_available,
        retired_clinician,
        last_date_of_practise,
        volunteer,
        preferred_locations,
        profile_picture,
        job_reference,
        highest_qualification_name,
        highest_qualification_acronym,
        last_date_of_login,
        created_on,
        display_uid,
        profile_completion_level,
      } = Object.assign(this.candidateProfile, {
        title: this.candidateProfile.title || {},
        speciality: this.candidateProfile.speciality || {},
        sub_speciality: this.candidateProfile.sub_speciality || {},
        candidate_level: this.candidateProfile.candidate_level || {},
        nationality: this.candidateProfile.nationality_names || [],
        main_qualification: this.candidateProfile.main_qualification || {},
        gender: this.candidateProfile.gender || { gender: "" },
        location: this.candidateProfile.current_country?.country_name || "",
        candidate_uid: this.candidateProfile.candidate_uid || null,
        display_uid: this.candidateProfile.display_uid || null,
        whatsapp: this.candidateProfile.whatsapp || "",
        available: this.candidateProfile.available || null,
        local_license: this.candidateProfile.local_license,
        dataflow_complete: this.candidateProfile.dataflow_complete,
        flexible: this.candidateProfile.flexible,
        extra_hours_available:
          this.candidateProfile.extra_hours_available || "--",
        retired_clinician: this.checkData(
          this.candidateProfile.retired_clinician
        ),
        volunteer: this.checkData(this.candidateProfile.volunteer),
        highest_qualification_name:
          this.candidateProfile.highest_qualification_name || null,
        highest_qualification_acronym:
          this.candidateProfile.highest_qualification_acronym || null,
        last_date_of_login: this.candidateProfile.last_date_of_login,
        created_on: this.candidateProfile.created_on,
        profile_completion_level:
          this.candidateProfile.profile_completion_level,
      });

      var availability_summary = [];
      if (job_type) {
        availability_summary.push(job_type);
      }
      if (job_time) {
        availability_summary.push(job_time);
      }
      if (
        this.candidateProfile.preferred_locations &&
        this.candidateProfile.preferred_locations.length
      ) {
        preferred_locations = this.candidateProfile.preferred_locations
          .map((value) => value?.location?.comments)
          .join(", ");
      } else preferred_locations = "--";

      eligibility_letter_available_for = eligibility_letter_available_for
        ? eligibility_letter_available_for.split(",").join(", ")
        : "--";
      if (this.candidateProfile?.doh_candidate_status?.job_id) {
        job_reference = `${this.candidateProfile.doh_candidate_status?.job_title} | 
        ${this.candidateProfile.doh_candidate_status?.customer_id} - ${this.candidateProfile.doh_candidate_status?.job_id}`;
      } else job_reference = "--";
      return {
        jobStatus: this.jobStatus,
        first_name,
        surname,
        gender,
        title,
        speciality,
        sub_speciality,
        candidate_level,
        candidate_type,
        nationality,
        dob,
        email,
        age,
        qualification,
        main_qualification_year,
        phone,
        whatsapp,
        eligibility_letter_available_for,
        local_license,
        dataflow_complete,
        flexible,
        candidate_uid,
        availability_summary,
        extra_hours_available,
        location,
        retired_clinician,
        last_date_of_practise,
        volunteer,
        preferred_locations,
        profile_picture,
        job_reference,
        highest_qualification_name,
        highest_qualification_acronym,
        last_date_of_login,
        created_on,
        display_uid,
        profile_completion_level,
      };
    },
    courseProgramme() {
      const courseProviderUrls= {
        slc: "https://slc-campus.avallainmagnet.com/merospharm",
        bca: "https://slc-campus.avallainmagnet.com/bca",
      };
      return this.getCandidateCourseProgramme.map((item) => {
        const delivery_type = item.training_course?.study_mode_name
          ?.map((mode) => mode?.study_mode)
          ?.join(", ");
        const providerLogs = this.getLogo(
          item.training_course?.course_provider
        );
        const courseProviderUrl = this.isOnline(delivery_type)
          ? courseProviderUrls[this.getPathAcronymFromAccessToken] ||
            courseProviderUrls["slc"]
          : null;
        return {
          course_ref: item.training_course?.course_ref,
          course_provider_name: item.training_course?.course_provider,
          course_provider_logo: providerLogs,
          course_type: item.training_course?.course_test_type_name,
          course_title: item.training_course?.course_title,
          delivery_type: delivery_type,
          progress: item.study_hours_completed,
          course_provider_url: courseProviderUrl,
        };
      });
    },
  },
  methods: {
    ...mapActions([
      "fetchAppliedJobCount",
      "fetchWithdrawJobCount",
      "fetchFavoJobCount",
      "fetchMatchedJobCount",
      "fetchCandidateLoginAlerts",
      "fetchCandidateInterviewSchedule",
      "fetchUploadedDocument",
      "fetchOffersDocsForCandidate",
      "fetchOnBoardDocsForCandidate",
      "fetchDocsForCandidate",
      "fetchCandidateEmailMessages",
      "fetchCandidateCourseProgramme",
      "fetchCandidateCampaignsCount",
      "getCourseList",
    ]),
    getLogo(provider) {
      const providerLogs = {
        slc: "/img/stm/slc_logo.png",
        meros: "/img/stm/meros.png",
      };
      const providerName = provider?.toLowerCase()?.includes("meros")
        ? "meros"
        : "slc";
      return providerLogs[providerName] || "/img/stm/slc_logo.png";
    },
    isOnline(delivery_type) {
      const types = {
        online: true,
        offline: false,
      };
      const providerName = delivery_type?.toLowerCase()?.includes("online")
        ? "online"
        : "offline";
      return types[providerName];
    },
    checkData(value) {
      if (value !== null) {
        return value === "Yes" || value === true ? "Yes" : "No";
      }
      return "--";
    },
    setTabActive(index) {
      this.activeTab = index;
      this.activeTabName = this.tabNames[index] || 'overview';
      const newQuery = { ...this.$route.query };
      delete newQuery.tab;

      this.$router.replace({
        query: newQuery,
      });
    },
  },
  async mounted() {
    const tabFromUrl = this.$route.query.tab;

    if (tabFromUrl !== undefined) {
      let index = -1;

      if (!isNaN(tabFromUrl)) {
        index = parseInt(tabFromUrl);
      } else {
        index = this.tabNames.indexOf(tabFromUrl);
      }

      if (index >= 0 && index < this.tabNames.length) {
        this.activeTab = index;
        this.activeTabName = this.tabNames[index];
      }
    }
    await this.$store.dispatch("getUserMe", { customer: this.getCustomerId });
    await this.fetchCandidateInterviewSchedule();
    const { customer_uid, candidate_uid, organisation_id } =
      this.candidateProfile;
    let payload = { customer_uid, candidate_uid };

    await this.fetchCandidateEmailMessages({ customer_uid, candidate_uid });

    if (
      this.getCustomerTypeIDFromAccessToken !==
        CONST.CUSTOMER_TYPE.recruiter_agency &&
      organisation_id
    ) {
      payload = { ...payload, organisation_id };
    }

    this.fetchUploadedDocument();
    this.fetchWithdrawJobCount();
    this.fetchDocsForCandidate({
      ...payload,
      action_type__in: ["pre_offer", "offer", "licensing", "visa", "joining"],
    });

    this.fetchMatchedJobCount();
    this.fetchFavoJobCount();
    this.fetchAppliedJobCount();
    this.fetchCandidateCourseProgramme();
    this.fetchCandidateCampaignsCount();
    this.getCourseList({ query: "moodle_synced=true" });

    const alerts = await this.fetchCandidateLoginAlerts();
    if (Array.isArray(alerts) && alerts.length > 0) {
      this.showLoginAlert = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  padding: 0.5rem 0.5rem 0 0.5rem;
  min-height: 100vh;
  overflow: visible;

  /* Hide all scrollbars in the container */
  ::v-deep {
    .c-body,
    .tab-content,
    .tab-pane,
    .d-block.d-md-none > div {
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;
      /* IE and Edge */

      &::-webkit-scrollbar {
        display: none;
        /* Chrome, Safari and Opera */
      }
    }

    .c-body,
    .tab-content,
    .tab-pane,
    .d-block.d-md-none > div {
      overflow-y: auto;
    }
  }
}

.row {
  margin-right: 0;
  margin-left: 0;
  flex-wrap: wrap;
  align-items: flex-start;
}

.col-12.col-md-4.col-lg-3 {
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  height: auto;
}

.col-12.col-md-8.col-lg-9.flex-grow-1 {
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  min-height: unset;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  height: auto;
  overflow-x: auto;
  overflow-y: auto;
  max-width: 100%;

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.home-tabs {
  ::v-deep .nav-tabs {
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.25rem;
    column-gap: 0.25rem;
    white-space: nowrap;
    overflow: visible;
    margin-inline-start: 0;
    margin-block-start: 0;
    margin-left: 0;
    border-bottom: none;
  }

  ::v-deep .nav-item,
  ::v-deep .nav-link {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  ::v-deep .nav-link {
    padding: 0.35rem 0.6rem;
    font-size: 13px;
    color: var(--primary);
    background: #fff;
    border: 1px solid #e6e6ef;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s, border-color 0.2s;
  }

  ::v-deep .nav-link.active {
    background: linear-gradient(
      249.32deg,
      #00dfff -33.55%,
      #4c34e9 51.72%,
      #ff00ff 138.57%
    ) !important;
    color: #fff !important;
    border-color: transparent !important;
    box-shadow: 0 3px 10px rgba(76, 52, 233, 0.25);
  }

  ::v-deep .tab-content {
    min-height: 300px;
    display: flex;
    flex-direction: column;
    background: #fff;

    .tab-pane {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 1rem;
    }
  }
}

/* Mobile tab content */
.d-block.d-md-none > div {
  min-height: 300px;
  background: #fff;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .home-container {
    padding: 0.25rem;

    .row {
      flex-direction: column;
      align-items: stretch;
    }

    .col-12.col-md-4.col-lg-3,
    .col-12.col-md-8.col-lg-9.flex-grow-1 {
      width: 100%;
      max-width: 100%;
      margin-bottom: 0.5rem;
      padding-left: 0;
      padding-right: 0;
      min-height: unset;
    }

    .col-12.col-md-8.col-lg-9.flex-grow-1 {
      border-radius: 8px;
      min-height: unset;
    }
  }
}

@media (max-width: 767.98px) {
  .home-container {
    padding: 0.1rem;

    .row {
      flex-direction: column;
      align-items: stretch;
    }

    .col-12.col-md-4.col-lg-3,
    .col-12.col-md-8.col-lg-9.flex-grow-1 {
      width: 100%;
      max-width: 100%;
      margin-bottom: 0.5rem;
      padding-left: 0;
      padding-right: 0;
      min-height: unset;
    }

    .col-12.col-md-8.col-lg-9.flex-grow-1 {
      border-radius: 8px;
      min-height: unset;
      box-shadow: none;
    }
  }
}

/* Global font size adjustment */
.home-container,
.home-container * {
  font-size: 13px !important;
}

/* Coming soon components styling */
.coming-soon-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 2rem;
  text-align: center;

  h1 {
    font-size: 1.5rem;
    font-family: "Poppins", sans-serif;
    margin-bottom: 1rem;
    color: #2e2964;

    .dot {
      color: #4c34e9;
    }
  }

  p {
    font-family: "Space Grotesk", sans-serif;
    color: #666;
    max-width: 500px;
    margin: 0 auto;
  }
}
</style>
